import { c as _c } from "react/compiler-runtime";
import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
type CommandEmptyProps = ComponentPropsWithoutRef<typeof CommandPrimitive.Empty>;
const CommandEmpty = forwardRef<HTMLDivElement, CommandEmptyProps>((t0, ref) => {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props || $[5] !== ref) {
    t1 = <CommandPrimitive.Empty ref={ref} {...props} className="flex flex-col items-center justify-center p-4 text-center text-body-2 text-tertiary">{children}</CommandPrimitive.Empty>;
    $[3] = children;
    $[4] = props;
    $[5] = ref;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
});
export default CommandEmpty;